import { put, takeLatest } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";
import {
  getCountriesListFailure,
  getCountriesListSuccess,
  getStatesByCountryFailure,
  getStatesByCountrySuccess,
} from "./slice";
import { LOCATION_REQUEST } from "./types";
import { axiosInstance } from "../../utils/AxiosInstance";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function* getCountriesList() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/locations/countries`
    );
    yield put(getCountriesListSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getCountriesListFailure({ error: err.response?.data }));
  }
}

function* getStatesByCountry(action: any) {
  const { country } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/locations/countries/${country}/states`
    );
    yield put(getStatesByCountrySuccess({ response: {country, states: response?.data} }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getStatesByCountryFailure({ error: err.response?.data }));
  }
}

export function* locationSaga() {
  yield takeLatest(
    `${LOCATION_REQUEST}/getCountriesListRequest`,
    getCountriesList
  );
  yield takeLatest(
    `${LOCATION_REQUEST}/getStatesByCountryRequest`,
    getStatesByCountry
  );
}
